// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"s6-z","displaySixCardTiles":"t6-z"};